export const categories = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱韩漫故事' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '穿越异世界的奇幻冒险之旅' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血激燃的动作战斗漫画' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理故事' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松愉快的搞笑日常漫画' },
  { slug: 'drama', name: '剧情', icon: 'ri-movie-2-line', description: '深刻动人的剧情向韩漫' },
];

export const categoryMap: Record<string, string> = {
  romance: '恋爱',
  fantasy: '奇幻',
  action: '动作',
  thriller: '悬疑',
  comedy: '搞笑',
  drama: '剧情',
};